import { NavLink, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { House, UsersThree, ChatCircleDots, Compass, EnvelopeSimple, SignOut, Flower, ChartLineUp, Sparkle } from "@phosphor-icons/react";
import SiteFooter from "@/components/SiteFooter";

const NAV = [
  { to: "/app", label: "Timeline", icon: House, testid: "nav-timeline" },
  { to: "/app/matches", label: "Matches", icon: UsersThree, testid: "nav-matches" },
  { to: "/app/navigator", label: "AI Navigator", icon: Compass, testid: "nav-navigator" },
  { to: "/app/messages", label: "Messages", icon: EnvelopeSimple, testid: "nav-messages" },
  { to: "/app/analytics", label: "Analytics", icon: ChartLineUp, testid: "nav-analytics" },
];

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="glass sticky top-0 z-40">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to="/app" data-testid="brand-link" className="flex items-center gap-2">
            <Flower size={26} weight="duotone" className="text-coral-700" />
            <span className="font-display text-2xl">Wingwomen</span>
          </Link>
          <nav className="hidden md:flex items-center gap-1">
            {NAV.map(({ to, label, icon: Icon, testid }) => (
              <NavLink key={to} to={to} end={to === "/app"} data-testid={testid}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded-full text-sm transition-colors ${
                    isActive ? "bg-coral text-white" : "text-ink hover:bg-muted"
                  }`
                }>
                <Icon size={18} weight="duotone" />
                {label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            {user?.premium && (
              <span className="hidden sm:inline-flex items-center gap-1 text-[10px] tracking-[0.15em] uppercase bg-coral-50 text-coral-700 border border-coral-100 px-2 py-1 rounded-full" data-testid="premium-badge">
                <Sparkle size={10} weight="fill" /> Premium
              </span>
            )}
            <span className="hidden sm:inline text-sm text-muted-foreground" data-testid="user-anon">
              {user?.anon_name}
            </span>
            <button
              onClick={() => { logout(); nav("/"); }}
              data-testid="logout-btn"
              className="p-2 rounded-full hover:bg-muted transition-colors"
              aria-label="Log out"
            >
              <SignOut size={18} weight="duotone" />
            </button>
          </div>
        </div>
        {/* mobile nav */}
        <nav className="md:hidden border-t border-border overflow-x-auto wing-scroll">
          <div className="flex gap-1 px-4 py-2">
            {NAV.map(({ to, label, icon: Icon, testid }) => (
              <NavLink key={to} to={to} end={to === "/app"} data-testid={`m-${testid}`}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs whitespace-nowrap ${
                    isActive ? "bg-coral text-white" : "bg-muted text-ink"
                  }`
                }>
                <Icon size={14} weight="duotone" />{label}
              </NavLink>
            ))}
          </div>
        </nav>
      </header>
      <main id="main-content" tabIndex={-1} className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10">{children}</main>
      <SiteFooter compact />
    </div>
  );
}
